














import { Component, Prop, Vue } from 'vue-property-decorator'
import { PopupAlign, PopupValign } from '@/components/Popup.vue'

@Component
export default class InformationPopup extends Vue {
    @Prop({ default: PopupAlign.left }) readonly align!: PopupAlign
    @Prop({ default: PopupValign.top }) readonly valign!: PopupValign
}
